import { render } from "./Difficulties.vue?vue&type=template&id=27a4750e&scoped=true"
import script from "./Difficulties.vue?vue&type=script&lang=js"
export * from "./Difficulties.vue?vue&type=script&lang=js"

import "./Difficulties.vue?vue&type=style&index=0&id=27a4750e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a4750e"]])

export default __exports__